@if (!loggedIn()) {
  <div class="flex justify-center items-center min-h-screen py-8 px-4">
    <div class="flex flex-col items-center justify-center w-full sm:w-auto">
      <div
        class="flex flex-col justify-between items-center w-full sm:w-[60vw] max-w-[420px] min-h-[360px] py-5 px-4 sm:px-0 bg-[var(--background-primary-color)] rounded-lg border-[1px] border-[var(--header-border)]"
      >
        @if (!logoId()) {
          <img
            class="h-[56px] sm:h-[70px] w-auto pl-2 mt-4 cursor-pointer"
            src="./../../../assets/logo/logo_full.png"
            alt="logo"
            [routerLink]="['/home']"
          />
        } @else {
          <div class="h-[56px] sm:h-[70px] w-auto pl-2 mt-4 cursor-pointer" routerLink="/home">
            <image [id]="logoId()" [props]="'h-[56px] sm:h-[70px] w-auto'"></image>
          </div>
        }

        @if (isLoginForm) {
          <form
            [formGroup]="loginForm"
            (ngSubmit)="submit()"
            class="flex flex-col items-center w-full text-center"
            autocomplete="on"
          >
            <p class="title my-4">Hello, Good to see you!</p>
            <p class="label mb-4">Sign In</p>

            <text-field
              [placeholder]="'Enter your email'"
              [control]="email"
              [corners]="true"
              tabindex="1"
              [error]="
                email.invalid && email.touched
                  ? email.errors?.['required']
                    ? 'Email is required.'
                    : email.errors?.['email']
                      ? 'Invalid email address.'
                      : ''
                  : ''
              "
              class="w-[88%] sm:w-[74%]"
            ></text-field>

            <text-field
              [placeholder]="'Enter your Password'"
              [control]="password"
              [corners]="true"
              type="password"
              tabindex="2"
              [error]="
                password.invalid && password.touched
                  ? password.errors?.['required']
                    ? 'Password is required.'
                    : password.errors?.['minlength']
                      ? 'Password must be at least 4 characters.'
                      : password.errors?.['maxlength']
                        ? 'Password must be less than 120 characters.'
                        : ''
                  : ''
              "
              class="my-5 w-[88%] sm:w-[74%]"
            ></text-field>

            <p class="text-[var(--text-primary)] font-medium text-xs mb-4">
              <a class="link" (click)="forgotPassword()" (keypress)="({})" tabindex="3"> Forgot Your Password? </a>
            </p>

            <common-button label="Sign In" size="L" type="submit" tabindex="4" [disabled]="loginForm.invalid">
            </common-button>
          </form>
        } @else {
          <p class="label my-4">Enter Your Email To Reset Password</p>

          <div class="flex flex-col w-full items-center">
            <text-field
              [placeholder]="'Enter your email'"
              [control]="email"
              [corners]="true"
              [error]="
                email.invalid && email.touched
                  ? email.errors?.['required']
                    ? 'Email is required.'
                    : email.errors?.['email']
                      ? 'Invalid email address.'
                      : ''
                  : ''
              "
              class="w-[88%] sm:w-[74%]"
            >
            </text-field>

            <p class="text-[var(--text-primary)] text-sm font-medium my-4 mx-4 text-center">
              Don't have access to your email anymore?
              <a href="/general/contact-us" class="link text-nowrap">Contact Admin</a>
            </p>
          </div>

          <common-button (click)="sendRequestToResetPassword()" label="Submit" size="L" [disabled]="email.invalid">
          </common-button>
        }
      </div>

      <p class="text-[var(--text-primary)] text-sm font-medium my-4 text-center">
        {{ isLoginForm ? "Don't have an account yet?" : 'Already have an account?' }}

        @if (isLoginForm) {
          <a href="/registration" class="link">Sign up now</a>
        } @else {
          <a class="link" (click)="isLoginForm = true" (keypress)="({})" tabindex="1">Back to Login</a>
        }
      </p>
    </div>
  </div>
}
